define('views/modules/conversation/message/new-message-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/conversation/conversation',
    'collections/member/supervisors',
    // views
    'views/parts/list/fetch-list',
    'views/modules/conversation/message/message-list'
], function(
    // Libs
    _, Backbone, Mustache, U,
    //models
    MConversation,
    Supervisors,
    // views
    VMessageList
) {

    var VNewMessageList = VMessageList.extend({

        getItemOptions: function(options) {
            return _.extend(options, {
                supervisors: Supervisors
            }, _.pick(this.options, ['url', 'conversations']));
        },
    });

    return VNewMessageList;

});

